import glslCnoise from '@/libs/lygia/generative/cnoise.glsl';
import glslFBM from '@/libs/lygia/generative/fbm.glsl';
import glslNoised from '@/libs/lygia/generative/noised.glsl';

export const uniforms = () => ({
    u_burn_noiseScale: { value: 2.0 },
});

export const shaderChunks = {
    uniforms: /* glsl */ `
        uniform float u_burn_noiseScale;
    `,
    vertex: /* glsl */ `
        ${glslFBM}
        ${glslNoised}

        vec3 transition_burn_vertex(vec3 position, vec3 direction,  float progress, float time) {
            vec3 bb_corner = vec3(0.38145, 0.68065, 0.09208);

            // float progress = uProgress;
            float padding = 1.0;
            float progressMapped = mix(-1.2, 0.91, progress);
            // // Calculate world position
            // vec3 worldPos = (modelMatrix * vec4(position, 1.0)).xyz;
            
            // // Get transition value similar to fragment shader
            float transitionValue = getTransitionValue(position, progressMapped);
            
            // Create noise similar to fragment shader
            float noiseScale = 0.1;
            float timeScale = 0.04;
            vec3 noiseInput = position * noiseScale + vec3(time * timeScale);
            
            float noise = fbm(noiseInput) * 0.5;
            // noise *= fbm(noiseInput * 2.0);
            
            // Calculate dissolve value and edge
            float dissolveValue = (transitionValue);
            float edge = 1.0 - smoothstep(0.0, 1.0, abs(dissolveValue));
            
            // // Distort vertices along normal at the edge
            float distortionAmount = pow(min(1.0, max(0.0, edge)), 10.0)* 0.02; // Adjust this value to control the distortion strength

            vec3 dir = direction + noised(position * vec3(2.1) + vec3(time* .25)).xyz * 1.0;
            vec3 distortedPosition = position + normalize(dir)* distortionAmount;
            // distortedPosition += direction * vec3(noise);
            // vec3 newNormal = normal;
            // // Final position calculation
            // vPosition = position;
            // vNormal = normalize(newNormal);

            // vWorldPosition = (modelMatrix * vec4(distortedPosition, 1.0)).xyz;
            // gl_Position = projectionMatrix * modelViewMatrix * vec4(distortedPosition, 1.0);
            return distortedPosition;
        }
    `,
    funcs: /* glsl */ `

        ${glslCnoise}
        ${glslFBM}

        vec3 hsv2rgb_burn(vec3 c) {
            vec4 K = vec4(1.0, 2.0/3.0, 1.0/3.0, 3.0);
            vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
            return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
        }

        vec4 transition_burn(vec3 position, vec3 normal, float progress, float time, bool useDiscard) {
            // float progress = uProgress;
            vec3 bb_corner = vec3(0.38145, 0.68065, 0.09208);
            float padding = 1.0;
            progress = mix(-1.2, 0.91, progress);
            // Get transition value from common function
            float transitionValue = getTransitionValue(position* vec3(1.0, 1.0, 1.0) + vec3(0.0,  -position.z * 1.0, bb_corner.z*2.0), progress);
            // Create finer animated noise using Lygia's FBM (Fractal Brownian Motion)
            float noiseScale = u_burn_noiseScale;
            float timeScale = 0.04;
            vec3 noiseInput = position * noiseScale + time * timeScale;
            
            // Layer multiple noise functions for more organic effect
            float noise = fbm(noiseInput) * 0.5;
            noise *= fbm(noiseInput*1.0)*1.0;
            // Combine transition and noise for the dissolve effect
            float dissolveValue = transitionValue - noise;


            // dissolveValue = (pow(dissolveValue, 2.0)) * sign(dissolveValue);
            float edge = 1.0 - smoothstep(0.0, 0.3, abs(dissolveValue));
            
            // Calculate rainbow color
            float hue = pow(dissolveValue * 50.0, 0.55) + .4 - time;
            vec3 rainbowColor = pow(hsv2rgb_burn(vec3(hue, 1.0, 1.0)), 1.0-vec3(edge));
            
            // Mix colors with edge-aware factor

            vec3 n = vNormal;
            n.xy *= 1.0+ edge*2.0;
            n.z *= max(0.0, 1.0 - edge*1.0);
            vec3 baseColor = vec3(0.0);

            // Add backface tinting
            // if (!gl_FrontFacing) {
            //     baseColor *= vec3(0.5); // Warm orange tint for backfaces
            //     // baseColor += edge * 0.1; // Extra glow on edges for backfaces
            // }

            float mixFactor =  min(1.0, max(0.0,     1.0-pow(dissolveValue * 20.0, 0.05)));//smoothstep(0.0, 1.0, 1.0 - dissolveValue * 5.0);

            // vec3 finalColor = mix(baseColor, rainbowColor, mixFactor);
            vec3 finalColor = baseColor + rainbowColor * mixFactor;// + baseColor + rainbowColor * mixFactor*.6;
            finalColor = pow(finalColor, 1.0 + vec3(1.0*edge));
            
            float hue2 = pow(dissolveValue * 10.0, 0.2) + .4 - time + noise * 1.0;
            vec3 rainbowColor2 = hsv2rgb_burn(vec3(fract(hue2), 1.0, 1.0));
            
            finalColor *= 1.0 - ((bb_corner.z-position.z) / (bb_corner.z * 2.0)) * 0.5;
            finalColor += rainbowColor2 * edge * 0.1;
            finalColor = min(finalColor, vec3(1.0));
            finalColor *= 1.0 + pow(edge, 20.0) * 10.0;
            
            float visibility = smoothstep(0.0, 0.01, dissolveValue);
            if(visibility < 1.0 && useDiscard) {
                discard;
            }
            return vec4(finalColor, visibility);
        }

        vec4 transition_burn(vec3 position, vec3 normal, float progress, float time) {
            return transition_burn(position, normal, progress, time, false);
        }
    `,
};
